/* globals yaCounter22765936 yaCounter52537759 */

import vars from "../helpers";

const virtualHit = (path = location.href) => {
	if(vars.$html.hasClass('is-enter')) {
		if (window.yaCounter22765936) {
			yaCounter22765936.hit(path);
		}

		if (window.yaCounter52537759) {
			yaCounter52537759.hit(path);
		}
	}
};

export default {
	virtualHit,
};
